import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { fetchQuote, changeColor } from './actions/FetchAction';
import './App.css';

import QuoteContainer from './components/QuoteContainer';
	
class App extends Component {

  componentWillMount(){
	this.props.fetchQuote();
	this.props.changeColor();
  }

  render() {

	let style={
		backgroundColor: this.props.color
	}

    return (
      <div className="App" style={ style }>
	  	<QuoteContainer />
	  </div>
    );
  }
}

App.propTypes =  {
	fetchQuote: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
	color: state.settings.color	
});

export default connect(mapStateToProps, {fetchQuote, changeColor})(App);
